import { Component, OnInit } from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { Observable } from "rxjs-compat";
import { ApiService } from "../../services/api.service";
import { TimerService } from "../../services/timer.service";
import { WalletService } from "../../services/wallet.service";
import { WalletConnectDialogComponent } from "../../wallet-connect-dialog/wallet-connect-dialog.component";
import { Tabs } from "../tabs";
@Component({
    selector: "ngx-token-sale-details",
    templateUrl: "./token-sale-details.component.html",
    styleUrls: ["./token-sale-details.component.scss"],
})
export class TokenSaleDetailsComponent implements OnInit {
    isConnected = false;
    tabs = Tabs;
    contributionRules;
    private currentUserAddres = "";
    timeEnd;
    constructor(
        public _timerService: TimerService,
        public _walletService: WalletService,
        public _apiService: ApiService,
        public nbDialogService: NbDialogService
    ) {}
    openDialog() {
        this.nbDialogService.open(WalletConnectDialogComponent, {
            context: {},
        });
    }
    ngOnInit() {
        this.getCurrentStageRules();
        // this._timerService.getTime();
        this.checkwallet();
        this._walletService.checkWalletDisconnect();
    }

    connectWallet = async () => {
        this.currentUserAddres = await this._walletService.initConnection();
        // this._apiService.insertWhitelistedAddress(this.currentUserAddres).subscribe();
    };

    checkwallet = async () => {
        if (await this._walletService.checkWalletConnection()) {
            this.isConnected = false;
        } else {
            this.isConnected = true;
        }
    };

    getCurrentStageRules = async () => {
        this._apiService
            .getStageRules(1) // Currently 1, will recive from db
            .subscribe((res) => {
                this.contributionRules = res["stageRules"];
            });
    };
}
